import React, { useEffect, useState } from "react";

import axios from "axios";
import { Link } from "react-router-dom";

// Firebase config for the second project

const MiraiCareer = () => {
  const [jobs, setJobs] = useState([]);

  // Fetch job posts
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get("https://mirai-server.vercel.app/api/jobs");
        setJobs(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchJobs();
  }, []);

  return (
    <div>
      <div className="text-justify lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
        <div className="text-justify w-full  max-w-screen-2xl mx-auto p-4 ">
          <h1 className="text-justify lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">
            Job Circular
          </h1>

          {jobs.map((job) => (
            <Link to={`/career-details/${job._id}`}>
              <div className="text-justify w-full lg:mt-10 sm:mt-5 lg:p-5 sm:p-3 border hover:border-2 hover:bg-blue-50 hover:border-gray-900 duration-300 ease-in-out border-gray-500 shadow-md lg:rounded-xl sm:rounded-md">
                <p className="text-justify lg:text-lg sm:text-sm text-gray-400">
                  Posted on: {new Date(job.date).toLocaleDateString()}
                </p>
                <h1 className="text-justify text-xl mt-4 font-jost text-gray-900">
                  {job.title}
                </h1>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MiraiCareer;
